import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IGetCommonUserOAuthCredentialParams {
  ids: string[];        // Data source ids
}

export interface IGetCommonUserOAuthCredentialResult extends IResult {
  hasNone: boolean;             // true if any data source does not have any embedded authentication
  hasEmbeddedPassword: boolean; // true if any data source has an embedded password
  hasManagedKeychain: boolean;  // true if any data source uses a managed key chain
  hasOAuthCredential: boolean;  // true if any data source has an embedded OAuth credential
  oauthCredentialId?: string;   // If hasOAuthCredential is the only property that is true then
                                // this is the ID that is common to all data sources
  commonUsername?: string;      // If one of hasEmbeddedPassword, hasManagedKeychain, or hasOAuthCredential is the
                                // only true property then this is the username that is common to all data sources
}

export class GetCommonUserOAuthCredentialRequest
    extends Request<IGetCommonUserOAuthCredentialParams, IGetCommonUserOAuthCredentialResult> {
  constructor(params: IGetCommonUserOAuthCredentialParams) {
    super('getCommonUserOAuthCredential', params);
  }
}
